import { Button, Input, Modal, Textarea } from '@vwfs-bronson/bronson-react';
import { Job } from '../../fes';
import { openDatadogLogs } from './datadog';

function formatValue(value: string | number | undefined | null): string {
  if (value === undefined || value === null || value === '') {
    return '-';
  }

  return String(value);
}

function formatReference(id: string | undefined, name?: string): string {
  if (!id) {
    return '-';
  }

  return name ? `${name} (${id})` : id;
}

export function JobDetailPanel({
  job,
  agentName,
  teamName,
  lookupsLoading,
  lookupError,
  onClose,
}: {
  job: Job | null;
  agentName?: string;
  teamName?: string;
  lookupsLoading: boolean;
  lookupError?: string;
  onClose: () => void;
}) {
  if (!job) {
    return null;
  }

  const agentDisplay = lookupsLoading && job.agentId && !agentName ? 'Loading...' : formatReference(job.agentId, agentName);
  const teamDisplay = lookupsLoading && job.teamId && !teamName ? 'Loading...' : formatReference(job.teamId, teamName);

  return (
    <Modal
      buttonCloseLabel="Close job detail"
      buttonConfirmText="Close"
      onClose={onClose}
      onConfirm={onClose}
      shown
      title="Job detail"
    >
      <div className="app-actions app-job-detail-actions">
        <Button
          secondary
          icon="semantic-forward"
          onClick={() => openDatadogLogs(job.requestId)}
        >
          View Datadog logs
        </Button>
      </div>

      {lookupError ? (
        <div className="app-result app-team-error" role="alert">
          {lookupError}
        </div>
      ) : null}

      <div className="app-detail-grid">
        <label className="app-form-field app-form-field--readonly app-form-field--wide" htmlFor="job-request-id">
          <span>Request ID</span>
          <Input id="job-request-id" value={formatValue(job.requestId)} readOnly />
        </label>
        <label className="app-form-field app-form-field--readonly" htmlFor="job-installation-id">
          <span>Installation ID</span>
          <Input id="job-installation-id" value={formatValue(job.installationId)} readOnly />
        </label>
        <label className="app-form-field app-form-field--readonly" htmlFor="job-status">
          <span>Status</span>
          <Input id="job-status" value={formatValue(job.status)} readOnly />
        </label>
        <label className="app-form-field app-form-field--readonly" htmlFor="job-email">
          <span>Email</span>
          <Input id="job-email" value={formatValue(job.email)} readOnly />
        </label>
        <label className="app-form-field app-form-field--readonly" htmlFor="job-created-at">
          <span>Created At</span>
          <Input id="job-created-at" value={formatValue(job.createdAt)} readOnly />
        </label>
        <label className="app-form-field app-form-field--readonly" htmlFor="job-updated-at">
          <span>Updated At</span>
          <Input id="job-updated-at" value={formatValue(job.updatedAt)} readOnly />
        </label>
        <label className="app-form-field app-form-field--readonly" htmlFor="job-agent">
          <span>Agent</span>
          <Input id="job-agent" value={agentDisplay} readOnly />
        </label>
        <label className="app-form-field app-form-field--readonly" htmlFor="job-team">
          <span>Team</span>
          <Input id="job-team" value={teamDisplay} readOnly />
        </label>
        <label className="app-form-field app-form-field--readonly app-form-field--wide" htmlFor="job-initial-prompt">
          <span>Initial Prompt</span>
          <Textarea id="job-initial-prompt" value={formatValue(job.initialPrompt)} readOnly rows={5} />
        </label>
      </div>
    </Modal>
  );
}
